// // config.js
// const AUTH_API_URL = "http://localhost:3021/admin";
// const Client_API_URL = "http://localhost:3021/client";
// const VTT_API_URL = "http://localhost:5000";


// export { AUTH_API_URL,Client_API_URL,VTT_API_URL};


// config.js
// const AUTH_API_URL = "http://localhost:3021/admin";
// const Client_API_URL = "http://localhost:3021/client";
// const VTT_API_URL = "http://localhost:5000";
// const API_BASE = "http://172.168.100.62:5000";
// const BACKEND_URL = "http://localhost:3021/client";


// export { AUTH_API_URL, Client_API_URL, VTT_API_URL, API_BASE, BACKEND_URL };


const AUTH_API_URL = "https://crsapi.opticentcx.com:3053/admin";
const Client_API_URL = "https://crsapi.opticentcx.com/client";
const VTT_API_URL = "http://localhost:5000";
const API_BASE = "http://crstranslation.opticentcx.com:5000";
const BACKEND_URL = "https://crsapi.opticentcx.com/client";

export { AUTH_API_URL, Client_API_URL, VTT_API_URL, API_BASE, BACKEND_URL };